var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatumaires(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.373,0,0,5.373,0,12c0,6.627,5.373,12,12,12c6.627,0,12-5.373,12-12C24,5.373,18.627,0,12,0z  M19.499,10.228c-0.148,1.173-0.698,2.199-1.216,3.048c-1.332,2.183-3.426,4.362-6.055,6.301c-0.131,0.097-0.286,0.144-0.439,0.144 c-0.191,0-0.381-0.074-0.524-0.217l-4.436-4.446c-0.897-0.899-2.252-2.257-2.357-4.022C4.365,9.232,5.724,7.464,7.566,7.011 c1.429-0.351,3.049,0.088,4.232,1.103c0.762-0.662,1.666-1.398,2.621-1.758c1.434-0.541,2.937-0.353,3.922,0.491 C19.223,7.603,19.667,8.898,19.499,10.228z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.941,7.74c-0.835,0.316-1.706,1.08-2.474,1.755l-0.214,0.188 c-0.148,0.13-0.341,0.195-0.539,0.181c-0.197-0.014-0.379-0.106-0.508-0.255C10.53,8.823,9.539,8.369,8.588,8.369 c-0.227,0-0.451,0.026-0.669,0.079c-1.151,0.283-2.035,1.405-1.97,2.5c0.066,1.113,0.949,2.085,1.927,3.065l3.981,3.99 c2.237-1.725,4.015-3.617,5.163-5.497c0.436-0.715,0.898-1.567,1.011-2.463c0.107-0.842-0.144-1.636-0.653-2.072 C16.812,7.485,15.855,7.395,14.941,7.74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatumaires);
export default __webpack_public_path__ + "static/media/patumaires.c79204221a7e1528f05221985f61d122.svg";
export { ForwardRef as ReactComponent };